export const getCatalog = (state) => state.catalog
